import React from 'react';
import { styles } from './ChipTab.css';
import { useTrackingContext } from '../../Tracking';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import Chip from '@jbhi-fi/lanyard-ui/components/Chip';

export type ChipTabProps = {
  className?: string;
  label: string;
  subText?: string;
  onClick: (event: React.MouseEvent) => void;
  isActive: boolean;
  textAlign?: 'center' | 'start';
};

export const ChipTab = ({ className, label, subText, onClick, isActive, textAlign = 'center' }: ChipTabProps) => {
  const { tracker } = useTrackingContext();

  const handleClick: React.MouseEventHandler = event => {
    tracker.trackClick({ label: label, extraData: { moduleName: 'Carousel tab' } });
    onClick?.(event);
  };

  return (
    <Chip
      className={classNames(className, styles.chipTab({ isActive, textAlign }))}
      label={label}
      subText={subText}
      isActive={isActive}
      onClick={handleClick}
    />
  );
};
